import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { CheckoutReturnPage } from 'src/apps/checkout/app/V2/CheckoutReturn';

export const CHECKOUT_RETURN_PATH = '/store/checkout-return';

// Stripe returns the customer here after a redirect-based payment (e.g.
// PayPal), with the checkout session id and country so we can look up the
// payment outcome.
const searchSchema = z.object({
  country: z.string().min(1),
  session_id: z.string().min(1),
});

const permissiveSearchSchema = z.object({
  country: z.string().optional(),
  session_id: z.string().optional(),
});

export const Route = createFileRoute(
  '/_auth/_only-header/store/checkout-return'
)({
  // Keep route validation permissive so malformed Stripe return URLs can reach
  // beforeLoad and be redirected back to checkout instead of surfacing as a
  // router validation error. beforeLoad enforces the required non-empty values.
  validateSearch: zodValidator(permissiveSearchSchema),
  beforeLoad: ({ context, search }) => {
    if (!context.featureFlags.EnableCheckoutV2) {
      throw redirect({
        to: '/store',
      });
    }
    // If the required params are missing, send the customer back to
    // checkout rather than rendering a page that can never resolve.
    const result = searchSchema.safeParse(search);
    if (!result.success) {
      throw redirect({ to: '/store/checkout', replace: true });
    }
  },
  component: () => <CheckoutReturnPage />,
});
